import * as types from '../types'

/**
 * 订单数据
 * list: 订单列表数据
 * detail: 当前订单详情
 * types: 订单状态列表 (scroller)
 * @type {Object}
 */
const state = {
    list: [],
    detail: {
        _main: {
            _pay_type: '在线支付'
        },
        _status: {
            wait_status: ''
        }
    },
    types: [
        {
            id: 0,
            title: '全部订单'
        },
        {
            id: 1,
            title: '待付款'
        },
        {
            id: 3,
            title: '待发货'
        },
        {
            id: 4,
            title: '待收货'
        },
        {
            id: 5,
            title: '已完成'
        },
        {
            id: 8,
            title: '已删除'
        }
    ],
}

const getters = {

}

const mutations = {
    [types.CHANGE_ORDER_LIST] (state, list) {
        state.list = list
    },

    [types.AJAX_UPDATE_LIST] (state, params) {
        state.list = state.list.concat(params)
    },

    [types.CHANGE_ORDER_DETAIL] (state, params) {
        state.detail = params
    },

    //params.status == 2
    [types.AJAX_ORDER_STATUS] (state, params) {
        state.list.forEach((item) => {
            if (item.id == params.spu_id) {
                item.status = params.status
                if (params.status == 2) {
                    item._status.wait_status = '已取消'
                }

                item._subs.forEach((sub) => {
                    sub.status = params.status

                    if (params.status == 2) {
                        sub._status.wait_status = '已取消'
                    }
                })
            }
        })
    },

    //params.status == 2
    [types.AJAX_ORDER_DETAIL_STATUS] (state, params) {
        state.detail.status = params.status
        if (params.status == 2) {
            state.detail._status.wait_status = '已取消'
        }
    }

}

export default {
    state,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/order.js